import { TutorForm } from 'components/Forms/TutorForm';
import { TutorEmailValidationForm } from 'components/Forms/TutorForm/EmailValidationForm';
import { HorizontalSteps } from 'components/molecules/HorizontalSteps';
import { TutorPlanCard } from 'components/molecules/TutorPlan/TutorPlanCard';
import NavigationPrompt from 'components/NavigationPrompt';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { TutorPlanOrderResume } from 'components/TutorRegistration/TutorPlanOrderResume';
import { TutorRegistrationCreditCard } from 'components/TutorRegistration/TutorRegistrationCreditCard';
import { TutorRegistrationHeader } from 'components/TutorRegistration/TutorRegistrationHeader';
import {
  TutorUserRegistrationProvider,
  useTutorUserRegistration,
} from 'context';
import React from 'react';
import { useWatch } from 'react-hook-form';

import { Box, Container, Grid, Toolbar } from '@mui/material';
import { BillingAddressForm } from 'components/Forms/TutorForm/BillingAddressForm';
import { BillingAddressFormTutorRegistration } from 'components/Forms/TutorForm/BillingAddressFormTutorRegistration';
import { useParams } from 'react-router-dom';

const STEPS = ['Cadastro', 'Validação', 'Pagamento', 'Endereço de Cobrança', 'Resumo'];

const Component: React.FC = () => {
  document.title = 'Vet4all - Tutor';

  const { form, loading, handleBasicInformationsStep, plans, resume, setChosenPlan, chosenPlan } =
    useTutorUserRegistration();
  
  const activeStep = useWatch({ control: form.control, name: 'activeStep' });
  const { plan } = useParams<{ plan: string }>();

  switch (plan) {
    case 'trimestral':
      setChosenPlan('66f5334f64dc40fa2bdd1716');
      break;

    case 'anual':
      setChosenPlan('66f530ce64dc40fa2bdd1715');
      break;
  
    default:
      setChosenPlan('633ade6fd23307f1d6bea06f');
      break;
  }

  const steps = [
    <TutorForm onNextClick={form.handleSubmit(handleBasicInformationsStep)} />,
    <TutorEmailValidationForm />,
    <TutorRegistrationCreditCard />,
    <BillingAddressFormTutorRegistration />,
    <TutorPlanOrderResume resume={resume} />,
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />

        <Container sx={{ py: 3 }} maxWidth="xl">
          <NavigationPrompt block={form.formState.isDirty} />

          <Grid container spacing={5}>
            <Grid item xs={12} lg={8}>
              <PaperCardTemplate loading={loading} childrenProps={{ px: 6 }}>
                <TutorRegistrationHeader />

                <HorizontalSteps steps={STEPS} />

                {steps[activeStep]}
              </PaperCardTemplate>
            </Grid>

            <Grid item xs={12} lg={4}>
              <TutorPlanCard plan={plans.filter((plan) => plan.id === chosenPlan)[0]} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export const TutorRegistrationPage = () => {
  return (
    <TutorUserRegistrationProvider>
      <Component />
    </TutorUserRegistrationProvider>
  );
};
